import React, { useEffect, useRef, useState } from "react";
import EditIcon from "../assets/Icons/EditIcon";
import DeleteIcon from "../assets/Icons/DeleteIcon";
import { Link, useNavigate } from "react-router-dom";
import { DateFormatter, ROTUES } from "../utils/global";
import { useDispatch } from "react-redux";
import { updateProjectAction } from "../store/actions/projectAction";

const statusOptions = [
  {
    label: "Designing",
    value: "design",
  },
  {
    label: "Design Verification",
    value: "design_varification",
  },

  {
    label: "Order Placed",
    value: "order_placed",
  },
];

const statusOptionsMapping = [
  {
    label: "Designing",
    value: "design",
  },
  {
    label: "Design Verification",
    value: "design_varification",
  },

  {
    label: "Order Placed",
    value: "order_placed",
  },
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "In Production",
    value: "in_production",
  },

  {
    label: "Production complete",
    value: "production_complete",
  },
  {
    label: "Shipment",
    value: "shipment",
  },

  {
    label: "Completed",
    value: "completed",
  },
];

const compltedStatus = [
  "in_production",
  "production_complete",
  "shipment",
  "completed",
];

const ProjectsTable = ({ projects, handleDelete }) => {
  const navigate = useNavigate();

  const [dropdownIndex, setDropdownIndex] = useState(null);
  const dropdownRef = useRef(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState({ show: false, projectId: null });

  const dispatch = useDispatch();

  const toggleDropdown = (e, index) => {
    e.stopPropagation();
    setDropdownIndex(index === dropdownIndex ? null : index);
  };

  const handleEditAction = (id) => {
    navigate(`${ROTUES.dashboard}/${id}`);
  };

  // Handle showing the delete confirmation dialog
  const showDeleteConfirmation = (e, projectId) => {
    e.stopPropagation();
    setDeleteConfirmation({ show: true, projectId });
  };

  // Handle confirming the deletion
  const confirmDelete = () => {
    if (deleteConfirmation.projectId) {
      handleDelete(deleteConfirmation.projectId);
      setDeleteConfirmation({ show: false, projectId: null });
    }
  };

  // Handle canceling the deletion
  const cancelDelete = () => {
    setDeleteConfirmation({ show: false, projectId: null });
  };

  const handleStatusChange = (id, status) => {
    dispatch(
      updateProjectAction({
        id: id,
        status: status?.value,
      })
    )
      .unwrap()
      .then(() => setDropdownIndex(null));
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownIndex(null); // Close dropdown if clicked outside
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="">
      {/* Delete Confirmation Modal */}
      {deleteConfirmation.show && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="fixed inset-0 bg-black bg-opacity-50" onClick={cancelDelete}></div>
          <div className="bg-white p-6 rounded-lg shadow-lg z-10 max-w-md w-full">
            <h3 className="text-xl font-bold mb-4">Confirm Delete</h3>
            <p className="mb-6">Are you sure you want to delete this project? This action cannot be undone.</p>
            <div className="flex justify-end space-x-3">
              <button 
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
                onClick={cancelDelete}
              >
                Cancel
              </button>
              <button 
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                onClick={confirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      <table className="min-w-full bg-white">
        <thead>
          <tr>
            <th className="px-4 py-4 border-b text-left">Date</th>
            <th className="px-4 py-4 border-b text-left">Project Name</th>
            <th className="px-4 py-4 border-b text-left">Client Name</th>
            <th className="px-4 py-4 border-b text-left">Client Phone No.</th>
            <th className="px-4 py-4 border-b text-left">Pincode</th>
            <th className="px-4 py-4 border-b text-left">Status</th>
            <th className="px-4 py-4 border-b text-left">Notes</th>
            {/* <th className="px-4 py-4 border-b text-left">Token</th>
            <th className="px-4 py-4 border-b text-left">Password</th> */}
            <th className="px-4 py-4 border-b text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          {projects.map((project, index) => {
            const statusLabel = statusOptionsMapping?.find(
              (item) => item?.value == project?.status
            );
            const canEdit = compltedStatus.includes(project?.status);

            return (
              <tr key={index} className="hover:bg-gray-100">
                <td className="px-4 py-4 border-b">
                  {DateFormatter(project?.createdAt)}
                </td>
                <td className="px-4 py-4 border-b">{project.name}</td>
                <td className="px-4 py-4 border-b">{project.client_name}</td>
                <td className="px-4 py-4 border-b">{project.client_phone}</td>
                <td className="px-4 py-4 border-b">{project.postcode}</td>
                <td className="px-4 py-4 border-b">{statusLabel?.label}</td>
                <td className="px-4 py-4 border-b">
                  <div className="max-w-md">{project.notes}</div>
                </td>
                {/* <td className="px-4 py-4 border-b">{project?.token}rlazlq</td> */}
                {/* <td className="px-4 py-4 border-b">
                    {project?.password}4c8ntyj8
                  </td> */}
                <td className="px-4 py-4 border-b">
                  <div className="flex gap-2 items-center">
                    {!canEdit ? (
                      <button
                        className="text-green-500 hover:text-green-700"
                        onClick={() => handleEditAction(project._id)}
                      >
                        <EditIcon />
                      </button>
                    ) : (
                      <span style={{ visibility: "hidden" }}>
                        <EditIcon />
                      </span>
                    )}
                    <Link
                      to={`${ROTUES.downloadPdf}/${project?._id}`}
                      className="text-blue-500 hover:text-blue-700"
                    >
                      ⬇️
                    </Link>
                    {!canEdit ? (
                      <button
                        className="text-red-500 hover:text-red-700"
                        onClick={(e) => showDeleteConfirmation(e, project._id)}
                      >
                        <DeleteIcon />
                      </button>
                    ) : (
                      <span style={{ visibility: "hidden" }}>
                        <DeleteIcon />
                      </span>
                    )}

                    {!canEdit && (
                      <div className="relative">
                        <button
                          className="text-blue-500 hover:text-blue-700"
                          onClick={(e) => toggleDropdown(e, index)}
                        >
                          Change Status
                        </button>
                        {dropdownIndex === index && (
                          <div
                            className="absolute left-[-137px] bg-white border shadow rounded mt-2 z-10"
                            ref={dropdownRef}
                          >
                            {statusOptions.map((status) => (
                              <button
                                key={status?.value}
                                className="block px-4 py-2 text-left hover:bg-gray-100 w-52"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleStatusChange(project?._id, status);
                                }}
                              >
                                {status.label}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ProjectsTable;
